import Parameter from '../../Parameter';

import processParameters from '../../FormModel/utils/processParameters';

export default class ImageUpload extends Parameter {
  constructor(parameter) {
    super(parameter);
    this.params = processParameters(parameter.params, this.broadcast.bind(this));

    this.cropData = null;

    this.onChange = this.onChange.bind(this);
  }

  registerGetCropData = getCropData => {
    this.cropData = getCropData;
  };

  onChange(name, value) {
    this.params[name].value = value;
  }

  valueChanged() {
    return Object.keys(this.params).filter(key => this.params[key].valueChanged()).length > 0;
  }

  getPayloadValue() {
    const payload = Object.keys(this.params).map(key => {
      return this.params[key].getPayloadValue();
    });

    if (this.cropData) {
      this.cropData().forEach(item => payload.push({ name: item.name, value: item.value }));
    }
    return payload;
  }
}
